/* global axios */
import ApiClient from './ApiClient';

class IxcInvoiceNotificationDeliveriesAPI extends ApiClient {
  constructor() {
    super('ixc_invoice_notification_deliveries', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  status() {
    return axios.get(`${this.url}/status`);
  }

  pause() {
    return axios.post(`${this.url}/pause`);
  }

  resume() {
    return axios.post(`${this.url}/resume`);
  }

  cancel() {
    return axios.post(`${this.url}/cancel`);
  }

  resend(id) {
    return axios.post(`${this.url}/${id}/resend`);
  }

  testDelivery(payload) {
    return axios.post(`${this.url}/test_delivery`, payload);
  }

  importCsv(payload) {
    return axios.post(`${this.url}/import_csv`, payload);
  }
}

export default new IxcInvoiceNotificationDeliveriesAPI();
